<template>
  <div>
    <ContentAnalysis 
      class="mb-4" 
      @tabSwitch="$emit('tabSwitch', $event)" 
    />
    <AdvertisementList v-if="advertisements.length"
      discovery
      :advertisements="advertisements"
      :loading="loadingAdvertisements"
      :allAdsLoaded="allAdsLoaded"
      @updateAds="$emit('updateAds', $event)"
      @getMoreAds="$emit('getMoreAds')"
    />
    <SpyderEmptyState 
      v-else-if="!loadingAdvertisements"
      class="mt-16"
      :filters-applied="filtersApplied"
      :has-search-query="hasSearchQuery"
      @clearFilters="$emit('clearFilters')"
    />
  </div>
</template>

<script>
import AdvertisementList from '../../advertisements/AdvertisementList.vue'
import ContentAnalysis from '../../library/ContentAnalysis.vue'
import SpyderEmptyState from '../SpyderEmptyState.vue'

export default {
  name: 'AdLibraryBrandView',
  components: {
    AdvertisementList,
    ContentAnalysis,
    SpyderEmptyState
  },
  props: {
    advertisements: {
      type: Array,
      required: true
    },
    loadingAdvertisements: {
      type: Boolean,
      required: true
    },
    allAdsLoaded: {
      type: Boolean,
      default: false
    },
    brand: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    filtersApplied: {
      type: Boolean,
      default: false
    },
    hasSearchQuery: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>